import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import SearchBar from 'components/SearchBar'
import ToggleWithLabel from 'components/ToggleWithLabel'
import Toggle from 'components/Toggle'
import { useScrollPosition } from 'hooks/useScrollPosition'

import { setConfigurationFilter } from 'store/Configurations/actions'
import { setDeviceFilter } from 'store/Devices/actions'
import { setPrinterFilter } from 'store/Printers/actions'
import { getDevicesFilter } from 'store/AppState/selector'

const Navbar = (props) => {
  const {
    match,
    handleSwitch,
    isSwitchChecked,
    checkboxLabel,
    history,
    pendingDevicesNumber,
  } = props
  const [headerStyle, setHeaderStyle] = useState('')
  const dispatch = useDispatch()

  const filter = useSelector((state) => getDevicesFilter(state, 'status'))

  useScrollPosition(
    ({ prevPos, currPos }) => {
      // Math.abs(prevPos.y) is used to return always nagative number
      // It is used because of issue on safari, where we can
      // scroll above the height of document and it causes
      // problems with current position and prev position
      const isVisible = currPos.y > -Math.abs(prevPos.y)
      const classes = isVisible ? '-is-visible' : '-is-not-visible'

      setHeaderStyle(classes)
    },
    [headerStyle]
  )

  const handleChange = (event) => {
    handleSwitch(event.target.checked)
  }

  const redirectToAddNew = () => history.push(`${match.path}/new`)

  const handleTabChange = (event) => {
    dispatch(setDeviceFilter({ name: 'status', value: event.target.value }))
  }

  const handleSearch = (searchQuery) => {
    switch (match.path) {
      case '/configurations':
        dispatch(
          setConfigurationFilter({ name: 'searchQuery', value: searchQuery })
        )
        break

      case '/devices':
        dispatch(setDeviceFilter({ name: 'searchQuery', value: searchQuery }))
        break

      case '/printers':
        dispatch(setPrinterFilter({ name: 'searchQuery', value: searchQuery }))
        break

      default:
        break
    }
  }

  return (
    <nav className={cn(['navbar', headerStyle])}>
      {match.path === '/devices' && (
        <div className="navbar__hardware-toggle">
          <Toggle
            handleChange={handleTabChange}
            leftRadioConfig={{
              value: 'registered',
              label: 'Registered',
              isChecked: filter === 'registered',
            }}
            name="hardwareTab"
            rightRadioConfig={{
              value: 'pending',
              label: pendingDevicesNumber,
              isChecked: filter === 'pending',
            }}
          />
        </div>
      )}
      {checkboxLabel && (
        <ToggleWithLabel
          checked={isSwitchChecked}
          onChange={handleChange}
          label={checkboxLabel}
        />
      )}
      <SearchBar handleSearch={handleSearch} />
      <button className="btn new-item" type="button" onClick={redirectToAddNew}>
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </nav>
  )
}

Navbar.propTypes = {
  checkboxLabel: PropTypes.string,
  backTo: PropTypes.string,
  isSidebar: PropTypes.bool,
  handleSwitch: PropTypes.func,
  isSwitchChecked: PropTypes.bool,
  history: PropTypes.object,
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
  pendingDevicesNumber: PropTypes.string,
}

export default withRouter(Navbar)
